<template>
	<StandardModal
		open
		medium
		:title="$t('announcements_sent_to_title')"
		:confirmText="$t('common_button_done')"
		hideCancel
		:tabOrder="[
			{
				css: '.pronto-input input',
				clickOnEnter: true,
				Enter: () => {
					focusInput()
				},
			},
		]"
		@confirm="$emit('cancel')"
		@cancel="$emit('cancel')"
	>
		<div class="sent-to-modal">
			<div class="filtering">
				<Input
					:placeholder="$t('admin_people_search_action')"
					class="search"
					v-model="query"
					:icon="SearchIcon"
				/>
			</div>

			<Table :columns="columns" :rows="matchedGroups" hideHeader height="463px">
				<template #cell-group="{ data }">
					<div class="group-name">
						<div
							v-if="data.category"
							class="category"
							v-text="data.category.displayname"
						/>
						<div class="group" v-text="data.displayname" />
					</div>
				</template>

				<template #empty>
					<NoSearchResults :query="query" />
				</template>
			</Table>
		</div>
	</StandardModal>
</template>

<script>
import {
	StandardModal,
	Input,
	NoSearchResults,
	Table,
} from '@/components/common'
import { SearchIcon } from '@/icons'
import {
	getAnnouncement,
	getChat,
	getCategory,
	sortChatsByDisplayName,
} from '@/store'
import escapeRegEx from 'escape-string-regexp'

export default {
	name: 'AnnouncementSentToModal',
	components: { StandardModal, Input, NoSearchResults, Table },
	props: {
		announcementId: [String, Number],
	},
	data() {
		return {
			query: '',
			announcement: getAnnouncement(this.announcementId),
			columns: [{ field: 'group' }],
			SearchIcon,
		}
	},
	emits: ['cancel'],
	computed: {
		allGroups() {
			const { bubble_ids } = this.announcement?.targets || {}
			if (!bubble_ids) return []
			return bubble_ids
				.map(getChat)
				.map((g) => ({ ...g, category: getCategory(g.category_id) }))
				.filter((g) => g?.id)
				.sort(sortChatsByDisplayName)
		},
		matchedGroups() {
			if (!this.query) return this.allGroups
			const regex = new RegExp(escapeRegEx(this.query), 'i')
			return this.allGroups.filter(
				(g) => regex.test(g.displayname) || regex.test(g.category?.displayname)
			)
		},
	},
}
</script>

<style lang="scss" scoped>
@import 'src/sass/variables';

.sent-to-modal {
	@include flex-column;

	.filtering {
		border-bottom: 1px solid var(--neutral-200);
		padding: 14px 22px;
	}

	.table-container {
		flex-grow: 1;
		overflow-y: auto;

		.group-name {
			font-family: Avenir;
			font-style: normal;
			color: var(--neutral-800);

			.category {
				font-weight: normal;
				font-size: 12px;
				line-height: 16px;
				text-transform: uppercase;
				@include ellipsis;
			}

			.group {
				font-weight: 800;
				font-size: 15px;
				line-height: 20px;
			}
		}
	}
}
</style>
